<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
// import appConfig from "@/app.config";
import axios from 'axios';
/*
 * Edit Answer
 */
export default {
  page: {
    title: "Edit Answer",
    meta: [{ name: "description" }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      name: "Edit Answer",
      title: "Edit Answer Id:" + this.$route.params.id,
      headers: { headers: { "Content-Type": "application/json" } },
      items: [
        {
          text: "Answers",
          href: "/answers",
        },
      ],
      form: {
        answer_text: null,
        answer_lang: null,
        // answer_inputs: [],
        // need_user_account: 0,
        // has_related_form: 0,
        // selected_form: "",
        // has_related_function: 0,
        // selected_function: "",
        // has_parent_answer: 0,
        // parent_answer: "",
        // mapper_input: "",
        // selected_answer_push: "",
      },
      errors: null,
      submitted: false,
      pending: false,
      lang_list: [],
      formsList: [],
      functionsList: [],
      answersConfirmList: [],
      answersList: [],
      answerPushesList: [],
      edit_hook: 0,
      modal: {
        answer_input: "",
      },
      currrentAnswer: {},
    };
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
  methods: {
    async getCurrentAnswer() {
      let that = this;
      let url = process.env.VUE_APP_BASE_URL+`/api/Answers/show/${this.$route.params.id}`;
      await axios
        .get(url)
        .then(function (response) {
          that.currrentAnswer = response.data;
          that.form.answer_lang = response.data.lang_id;
          // that.form.answer_text = response.data.result[0].text;
          // that.form.need_user_account = that.currrentAnswer.registered;

          // if (
          //   that.currrentAnswer.availableInputs != null &&
          //   that.currrentAnswer.availableInputs.trim().length > 0
          // ) {
          //   let availableInputs = that.currrentAnswer.availableInputs.split("|");

          //   for (let index = 0; index < availableInputs.length; index++) {
          //     that.form.answer_inputs.push({
          //       id: index + 1,
          //       answer_input: availableInputs[index],
          //     });
          //   }
          // }

          // that.form.mapper_input =
          //   that.currrentAnswer.child_in_mapper != null
          //     ? that.currrentAnswer.child_in_mapper.input
          //     : "";
          // that.form.selected_answer_push =
          //   that.currrentAnswer.child_in_mapper != null
          //     ? that.currrentAnswer.child_in_mapper.answer_push_id
          //     : "";

          // if (that.currrentAnswer.form != null) {
          //   that.form.has_related_form = 1;
          //   that.form.selected_form = that.currrentAnswer.form.id;
          // }

          // if (that.currrentAnswer.method != null) {
          //   that.form.has_related_function = 1;
          //   that.form.selected_function = that.currrentAnswer.method.id;
          // }

          // if (that.currrentAnswer.parent_answer != null) {
          //   that.form.has_parent_answer = 1;
          //   that.form.parent_answer = that.currrentAnswer.parent_answer.id;
          // }
          that.form.answer_text =that.currrentAnswer.text;
          // if (that.currrentAnswer.text.length > 0) {
          //   for (let index = 0; index < that.currrentAnswer.text.length; index++) {
          //     that.form.answer_text[that.currrentAnswer.text[index].lang.id] =
          //       that.currrentAnswer.texts[index].text;
          //   }
          // }
        });
    },
    async getAnswerPushesList() {
      // let that = this;
      // await axios.get(appConfig.answers.list_pushes).then(function (response) {
      //   that.answerPushesList = response.data.result[0];
      // });
    },
    async getLanguageList() {
      let that = this;
      let url = process.env.VUE_APP_BASE_URL+'/api/Langs/list';
      await axios.get(url).then(function (response) {
        that.lang_list = response.data;
      });
    },
    async getFormsList() {
      // let that = this;
      // await axios.get(appConfig.answers.list_forms).then(function (response) {
      //   that.formsList = response.data.result[0];
      // });
    },
    async getFunctionsList() {
      // let that = this;
      // await axios.get(appConfig.answers.list_functions).then(function (response) {
      //   that.functionsList = response.data.result[0];
      // });
    },
    async getAnswersConfirmList() {
      // let that = this;
      // await axios.get(appConfig.answers.list_confirm).then(function (response) {
      //   that.answersConfirmList = response.data.result[0];
      // });
    },
    async getAnswersList() {
      // let that = this;
      // await axios.get("list-of/answers").then(function (response) {
      //   that.answersList = response.data.result[0];
      // });
    },
    generateAnsInputID() {
      return this.form.answer_inputs.length > 0
        ? this._.maxBy(this.form.answer_inputs, "id").id + 1
        : 1;
    },
    chackIfAnsHasInputs(parentAnswerId) {
      let answer = this._.filter(this.answersList, { id: parentAnswerId });
      return (
        answer.length > 0 &&
        answer[0] != undefined &&
        answer[0].availableInputs != null &&
        answer[0].availableInputs != ""
      );
    },
    getInputesFromAnswer(parentAnswerId) {
      let answer = this._.filter(this.answersList, { id: parentAnswerId });
      if (
        answer.length > 0 &&
        answer[0] != undefined &&
        answer[0].availableInputs != null &&
        answer[0].availableInputs != ""
      ) {
        return answer[0].availableInputs.split("|");
      }
      return [];
    },
    handleOk() {
      if (this.modal.answer_input.trim().length > 0) {
        let exist =
          this._.filter(this.form.answer_inputs, {
            answer_input: this.modal.answer_input,
          }).length > 0;

        if (!exist) {
          this.form.answer_inputs.push({
            id: this.generateAnsInputID(),
            answer_input: this.modal.answer_input,
          });

          this.modal.answer_input = "";

          this.$bvModal.hide("add-input");
        } else {
          this.$iziToast.error({
            message: "Input already added to this answer",
            position: "bottomCenter",
          });
        }
      }
    },
    handleUpdate() {
      if (this.modal.answer_input.trim().length > 0) {
        let exist =
          this._.filter(this.form.answer_inputs, {
            answer_input: this.modal.answer_input,
          }).length > 0;

        if (!exist) {
          let id = this.edit_hook;

          // delete old one
          this.form.answer_inputs = this._.filter(this.form.answer_inputs, function (o) {
            return o.id != id;
          });

          this.edit_hook = 0;
          // add newe one
          this.form.answer_inputs.push({
            id: this.generateAnsInputID(),
            answer_input: this.modal.answer_input,
          });

          this.modal.answer_input = "";

          this.$bvModal.hide("edit-input");
        } else {
          this.$iziToast.error({
            message: "Input already exists in this answer",
            position: "bottomCenter",
          });
        }
      }
    },
    handleCancel() {
      this.modal.answer_input = "";
      this.$bvModal.hide("add-input");
      this.$bvModal.hide("edit-input");
    },
    editAnswerInput(id) {
      this.edit_hook = id;

      let filterd = this._.filter(this.form.answer_inputs, function (o) {
        return o.id == id;
      });

      this.modal.answer_input = filterd[0].answer_input;

      this.edit_hook = 0;

      this.$bvModal.show("edit-input");
    },
    deleteAnswerInput(id) {
      let that = this;
      that.$swal
        .fire({
          title: "Confirm Delete",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#34c38f",
          confirmButtonColor: "#f46a6a",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            that.form.answer_inputs = this._.filter(
              that.form.answer_inputs,
              function (o) {
                return o.id != id;
              }
            );
          }
        });
    },

    formSubmit() {
      let that = this;
      that.submitted = true;

      var data = {
              "answer_text" : that.form.answer_text,
              "answer_lang" : that.form.answer_lang,
            };

      let url = process.env.VUE_APP_BASE_URL+`/api/Answers/update/${this.$route.params.id}`;
      axios
        .put(url, JSON.stringify(data), that.headers)
        .then(function (res) {
          console.log(res);
          that.submitted = false;
          that.$iziToast.success({
            message: "Updated Successfully!",
            position: "bottomCenter",
          });
          that.$router.push({ name: "Answers" });
        })
        .catch(function (error) {
          that.submitted = false;
          if (error.response) {
            that.errors = error.response.data.errors;
            window.scrollTo(0, 0);
          }
        });
    },
  },
  created() {
    this.pending = true;
    axios
      .all([
        this.getCurrentAnswer(),
        this.getLanguageList(),
        this.getFormsList(),
        this.getFunctionsList(),
        this.getAnswersConfirmList(),
        this.getAnswersList(),
        this.getAnswerPushesList(),
      ])
      .finally(() => (this.pending = false));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation" @submit.prevent="formSubmit">
              <fieldset :disabled="submitted || pending">
                <div class="row">
                  <div class="col-sm-7">
                    <div class="form-group">
                      <label class="">Answer Language</label>
                      <select v-model="form.answer_lang" class="form-control">
                        <option selected="true" disabled="disabled">
                          Select Language
                        </option>
                        <option v-for="lang in lang_list" :key="lang.id" :value="lang.id">
                          {{ lang.name }}
                        </option>
                      </select>
                    </div>
                    <!-- form-group -->

                    <div class="form-group" >
                      <div >
                        <label class=""> Answer Text</label>
                        <textarea
                          v-model="form.answer_text"
                          class="form-control"
                          rows="8"
                        ></textarea>
                      </div>
                    </div>
                    <!-- form-group -->
                  </div>
                  <!-- col-sm-6 -->

                  <!-- col-sm-6 -->
                </div>

                <button type="submit" class="btn btn-primary mr-1 float-right">
                  <span
                    v-show="submitted || pending"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-show="!submitted && !pending">Update</span>
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.answer_input_el {
  position: relative;
  display: inline-block;
  min-width: 60px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  z-index: 1;
  background-color: #fff;
  text-align: center;
  margin-right: 14px;
  margin-top: 30px;
  cursor: pointer;
}

.answer_input_el p {
  font-size: 18px;
  text-align: center;
  margin: 0;
  padding: 5px;
  z-index: 2;
  background-color: #fff;
}

.delete_input_el,
.edit_input_el {
  transition: top 0.3s ease;
}

.delete_input_el {
  position: absolute;
  top: 0;
  right: 1px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  z-index: -1;
}

.edit_input_el {
  position: absolute;
  top: 0;
  right: 19px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  z-index: -1;
}

.answer_input_el:hover .delete_input_el,
.answer_input_el:hover .edit_input_el {
  top: -22px;
}
</style>
